module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-11.1d860bf8.png";